<template>
    <div class="hbp-container hbp-container-above">
        <div class="announcement router-view">
            <!-- 公告图标 -->
            <div class="announcement-breadcrumb">
                <div aria-label="Breadcrumb"
                    role="navigation"
                    class="el-breadcrumb">
                    <span class="el-breadcrumb__item"
                        aria-current="page">
                        <span role="link"
                            class="el-breadcrumb__inner is-link">
                            <img src="../../images/ancmt-icon.png">
                            <span>
                                奖励计划
                            </span>
                        </span>
                        <i class="el-breadcrumb__separator el-icon-arrow-right">
                        </i>
                    </span>
                </div>
            </div>

            <!-- 公告列表 -->
            <div id="listLabel"
                class="announcement-panel">
                <div class="announcement-list">

                    <div class="announcement-list-content">
                        <xui-table :data="latestData"
                            :stripe="false"
                            :show-header="false"
                            @row-click="handleRow"
                            style="width: 100%">

                            <xui-table-column prop="title"
                                label=""
                                align="left">
                            </xui-table-column>

                            <xui-table-column prop="stickyOrder"
                                width="100"
                                label="">
                                <template slot-scope="scope">
                                    <span :style="scope.row.stickyOrder == 1 ? 'display:block' : 'display:none'">
                                        <img src="../../../src/images/ancmt-sticky.png"
                                            alt="">
                                    </span>
                                </template>
                            </xui-table-column>

                            <xui-table-column prop="creationDateStr"
                                class="is-top"
                                width="250"
                                label="">
                            </xui-table-column>

                        </xui-table>
                    </div>

                    <div id="pageLabel"
                        class="pager block">
                        <xui-pagination @current-change="handleCurrentChange"
                            :current-page.sync="currentPage"
                            :page-size="10"
                            layout="total, pager, jumper"
                            :total="total">
                        </xui-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HomeHeader from '../../components/Header.vue';
export default {
  name: 'program',
  components: { HomeHeader },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      latestData: [],
    };
  },
  mounted() {
    this.getAnnouncementInfo();
  },
  methods: {
    getAnnouncementInfo: function () {
      document.getElementById('pageLabel').style = 'display:none';
      document.getElementById('listLabel').style = 'display:none';
      let s = new Promise((resolve, reject) => {
        let params = {
          category: 5,
          stickyOrder: -1,
          status: 1,
        };
        this.$http
          .post('vul/hsrc/vul/report/services/announcement/page?pageNo=' + this.currentPage + '&pageSize=' + this.pageSize, params)
          .then((res) => {
            global.this_announcement = this;
            if (res.status === 200 && res.data.result) {
              this.latestData = res.data.result;
              this.total = res.data.pageVO.totalRows;
              document.getElementById('pageLabel').style = 'display:block';
              document.getElementById('listLabel').style = 'display:block';
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    handleRow(row, event, column) {
      this.$router.push({ path: '/program/detail', query: { code: row.announcementId } });
    },
    handleCurrentChange(val) {
      this.getAnnouncementInfo();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.xui-pager li {
  font-size: 16px !important;
  color: #303133;
  font-weight: 500;
}
/deep/.xui-pager li.active {
  color: #409eff;
  cursor: default;
}
/deep/.xui-pagination {
  .xui-pagination__total {
    float: none;
    margin-right: 30px !important;
    font-size: 16px;
    height: 32px;
    line-height: 32px;
  }
  .pageBtn,
  .xui-pagination__jump {
    float: none;
    font-size: 16px;
  }
  .xui-pagination__jump {
    float: none;
    margin-left: 30px;
    height: 32px;
    line-height: 32px;
    .xui-pagination__editor.xui-input {
      font-size: 16px;
    }
  }
}
/deep/.xui-table .cell {
  height: 57px;
  line-height: 57px;
  font-size: 0.8rem;
  color: #666;
  cursor: pointer;
}
.announcement-list .announcement-list-content {
  height: 680px;
}
.announcement-list .pager {
  text-align: center;
  margin: 1rem 0;
}
.hbp-container {
  width: 100%;
  min-height: 39rem;
  position: relative;
  overflow-y: scroll;
  .announcement {
    max-width: 63rem;
    margin: 0 auto;
    .announcement-breadcrumb {
      padding: 1rem 0.25rem;
      .el-breadcrumb {
        font-size: 14px;
        line-height: 1;
        .el-breadcrumb__item {
          height: 2rem;
          line-height: 2rem;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          .el-breadcrumb__inner {
            display: inline-flex;
            align-items: center;
            cursor: pointer;
            font-size: 0.8rem !important;
            span {
              padding: 0 0.25rem;
              font-size: 0.8rem !important;
            }
          }
          .is-link {
            font-weight: normal !important;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/program/Program.vue